<template>
    <div class="jd-select--periods jd-popup--con">
        <k-radio-group v-model="radio">
            <k-cell v-for="(value,key) in columns" :key="key">
                <k-radio :name="+key">{{value}}</k-radio>
            </k-cell>
        </k-radio-group>
    </div>
</template>

<script>
    export default {
        name: "select-radio",
        props : ["columns", "defaultIndex"],
        data(){
            return {
                radio : this.defaultIndex || ''
            }
        },
        watch : {
            radio(nv){
                this.$emit("change", {key:nv, text:this.columns[nv]})
            }
        }
    }
</script>

<style scoped>

</style>